import { Geometry, FeatureCollection as GeoJSONFeatureCollection } from 'geojson';

export type FeatureStatus = 'disabled' | 'empty' | 'reserved' | 'charging' | 'warning' | 'error' | 'self-test';

export enum FeatureStatusValues {
    disabled = 40,
    empty = 50,
    reserved = 60,
    charging = 70,
    warning = 80,
    'self-test' = 90,
    error = 100,
}
export interface Feature {
    type: 'Feature';
    properties: {
        id: string;
        stationId?: string; // if known, e.g. for connectors and satellites
        evseId?: string; // if known, for connectors
        located: boolean;
        parent?: string;
        name: string;
        text?: string;
        type: 'location' | 'satellite' | 'trolley' | 'connector' | 'cabinet' | 'image';
        /**
         * expired imageUrl, use backgroundImageFileKey to get new image download url from locationsApi.getLocationAttachmentsFileKey
         */
        url?: string;
        /**
         * fileKey of the image in s3 storage. Use this to get valid image download url from locationsApi.getLocationAttachmentsFileKey
         */
        backgroundImageFileKey?: string;
        /**
         * original name of the image file. Used to display user-friendly name in kp-map-feature-editor form
         */
        backgroundImageFileName?: string;
        rotation?: number;
        status?: FeatureStatus;
    };
    geometry: Geometry & {
        coordinates: [number, number] | [[number, number], [number, number]];
    };
}
export interface FeatureCollection extends GeoJSONFeatureCollection {
    type: 'FeatureCollection';
    features: Array<Feature>;
}

export interface ImageOnMap {
    file: File;
    coordinates: [[number, number], [number, number]];
}

export interface ImageInFeature {
    file: File;
    id: string;
}
